
import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, implementFunction } from "../../../framework/core/mvvm/module_base";
import ClubNoticeView from "./clubnotice_view";
import ModuleManager from "../../../framework/core/module_manager";
import LanguageManager from "../../../manager/language_manager";
import ModelData from "../../public/model_data";
import LoaclStorage from "../../../manager/local_storage";
const { ccclass, property } = cc._decorator;
@ccclass
@moduleInit("ClubNotice")
export default class ClubNotice extends ModuleBase<ClubNoticeView, null> {

    noticeContent
    clubinfo
    inEdit
    inYulan
    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/club/module/club_notice";
        this.viewType = ClubNoticeView;
        this.modelType = null;
        this.needAnim = false
    }
    protected onButtonClick(node: cc.Node) {

    }
    @bindButtonClickEvent("CloseBtn")
    closeBtn() {
        this.close()
    }
    @bindButtonClickEvent("marquee")
    marqueeClick() {
        this.view.showNotice(1, this.noticeContent)
    }
    @bindButtonClickEvent("EditBtn")
    EditBtn() {
        this.inEdit = true
        this.view.noticeEdit()
    }
    @bindButtonClickEvent("Mask")
    MaskClick() {
        this.close()
    }
    @bindButtonClickEvent("CancelEditBtn")
    CancelEditBtn() {
        let self = this
        if (this.view.noticeEditInput.string != this.view.noticeLabel.string) {
            ModuleManager.instance.showDialogConfirmCancel(LanguageManager.t('banknotice_cancel'), function () {
                self.view.noticeEditEnd(false)
                self.inEdit = false
                self.inYulan = false
            })
        } else {
            self.view.noticeEditEnd(false)
            self.inEdit = false
            this.inYulan = false
        }
    }
    @bindButtonClickEvent("SureEditBtn")
    SureEditBtn() {
        let self = this
        if (this.view.noticeEditInput.string == this.noticeContent) {
            self.view.noticeEditEnd(false)
            self.inEdit = false
            self.inYulan = false
            return
        }
        if (this.view.noticeEditInput.string == "") {
            ModuleManager.instance.showDialogConfirmCancel(LanguageManager.t('banknotice_null'), function () {
                self.editNotice(this.view.noticeEditInput.string)
            }, function () {
                self.view.noticeEditEnd(false)
                self.inEdit = false
                self.inYulan = false
            })
        } else {
            self.inEdit = false
            self.inYulan = false
            self.editNotice(this.view.noticeEditInput.string)
        }
    }
    @bindButtonClickEvent("SeeEditBtn")
    SeeEditBtn() {
        if (!this.inYulan) {
            this.view.noticeEditEnd(true)
            this.view.noticeFunc(false)
            this.inYulan = true
        } else {
            this.view.noticeEdit()
            this.inYulan = false
        }
    }
    close(){
        let self = this
        if (this.inEdit && this.view.noticeEditInput.string != this.view.noticeLabel.string) {
            ModuleManager.instance.showDialogConfirmCancel(LanguageManager.t('banknotice_cancel'), function () {
                self.view.showNotice(2)
            })
        } else {
            this.view.showNotice(2)
        }
    }
    onShow(intentData) {
        let self = this
        self.inYulan = false
        self.inEdit = false
        this.noticeContent = intentData.clubInfo.notice
        this.clubinfo = intentData.clubInfo
        this.view.noticeEvent.clubId = intentData.clubInfo.clubNum
        this.view.noticeEvent.userClubId = intentData.clubInfo.userClubId
        this.view.noticeEvent.module = this
        let tag = "isFirstOpenClub_Id" + ModelData.instance.roleData.id + "_club" + intentData.clubInfo.userClubId
        let isFirst = LoaclStorage.getString(tag,"")
        if (intentData.showType == "marquee") {
            this.view.showNotice(0, this.noticeContent)
            this.view.centerNode.active = false
            if(isFirst == ""){
                this.view.showNotice(1,this.noticeContent)
                LoaclStorage.setString(tag,"1")
            }
        } else {
            if (!this.clubinfo.isNoticeRead && this.noticeContent != undefined) {
                this.readNotice()
            }
            this.view.showNotice(1, this.noticeContent, this.clubinfo.ownerUserId == ModelData.instance.roleData.id)
        }
        this.eventBind("Event_Notify_Club_Notify_Change", function (content) {
            self.noticeContent = content
            self.view.showNotice(0, self.noticeContent)
            // if (!self.view.centerNode.active) {
            //     self.view.showNotice(0, self.noticeContent)
            // }
            if (self.clubinfo != null) {
                self.clubinfo.isNoticeRead = false
                self.clubinfo.notice = content
            }
        })
    }
    contentDeal(content) {
        `这里是公告，<size=52><color=#12a132>这里是公告</c></s>,<size=50><outline width=2 color=#00ff00><color=pink>这里是公告</c></c></s>

<color=red click="clickUrl" param="https://www.qq.com">点击这里</c>打开url

<color=green click="clickUrlInfo" param="https://www.qq.com">点击这里</c>打开带有参数的url

<color=yellow click="clickFacebook" param="bigwingame,103698947894958" describe="参数填写facebook主页host以及Facebook id,Facebook id 根据这个页面查询 https://findmyfbid.com/ ">点击这里</c>打开facebook主页

<color=blue click="clickLine" param="238hjrcl" describe="参数填写lineid,只支持LINE Official Account">点击这里</c>添加line好友`
    }

    private _get_http(url, param, success, fail?) {
        param.userClubId = this.clubinfo.userClubId
        let requestData = {
            baseUrl: url,
            params: param
        }
        this.apiHttpGet(requestData, function (retData) {
            success(retData.data)
        }, (retData) => {
            fail && fail(retData)
        })
    }

    readNotice() {
        let self = this
        this._get_http("club/manager/readClubNotice?", {}, function (data) {
            self.clubinfo.isNoticeRead = true
        })
    }
    editNotice(notice) {
        let self = this
        this._get_http("club/manager/updateClubNotice?", {
            notice: notice
        }, function () {
            self.clubinfo.notice = notice
            self.noticeContent = notice
            self.inEdit = false
            ModuleManager.instance.toast(LanguageManager.t('banknotice_suc'));
            self.view.noticeEditEnd(true)
            self.view.showNotice(0, self.noticeContent)
        })
    }


}
